import { IonBackButton, IonButton, IonButtons, IonHeader, IonTitle, IonToolbar } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import GolfIcon from '../GolfIcon';

type DiscussionsHeaderProps = {
  openNewChat: () => void;
};

export default function DiscussionsHeader({ openNewChat }: DiscussionsHeaderProps) {
  return (
    <>
      <IonHeader className="ion-no-border">
        <IonToolbar className='md:hidden px-2'>
          <IonButtons slot='start'>
            <IonBackButton text='' defaultHref='/dashboard' className='md:hidden text-foreground' icon={arrowBack} />
          </IonButtons>
          <IonTitle>Discussions</IonTitle>
          <IonButtons slot='end'>
            <IonButton
              type="button"
              color="transparent"
              onClick={openNewChat}
              className="text-foreground rounded-full p-2 hover:text-neutral-400 dark:hover:text-gray-700"
              title="Start a new chat"
            >
              <GolfIcon name='message-add' className='size-7 dark:invert' />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <div className="hidden md:flex h-16 border-b items-center justify-between p-3">
        <h2 className="text-2xl font-semibold">Discussions</h2>
        <button
          type="button"
          onClick={openNewChat}
          className="rounded-full p-2 hover:text-neutral-400 dark:hover:text-gray-700"
          title="Start a new chat"
        >
          <GolfIcon name='message-add' className='size-6 dark:invert' />
        </button>
      </div>
    </>
  );
}
